import { MeetingPage as MeetingScreen } from '../../features/meetings/MeetingPage'

/** S7 Meeting (investor view). */
export function MeetingPage() {
  return <MeetingScreen area="app" />
}
